import script from "./CommentsList.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentsList.vue?vue&type=script&setup=true&lang=js"

import "./CommentsList.vue?vue&type=style&index=0&id=41e1c2c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41e1c2c6"]])

export default __exports__